/**
 * Module-singleton handoff between the PartyBar portrait click and the
 * `MainMenu`'s `InventoryScreen` mount. PartyBar sets the desired member,
 * then sends `OPEN_MENU`; MainMenu reads + clears on mount so the screen
 * lands focused on the tapped character.
 *
 * A ref (rather than the EventBus) is used because the menu component is
 * not mounted at the moment the event would fire — its `useEffect`
 * listeners aren't registered yet.
 */
let pendingMemberId: string | null = null;

export function setPendingInventoryMember(characterId: string): void {
  pendingMemberId = characterId;
}

export function consumePendingInventoryMember(): string | null {
  const id = pendingMemberId;
  pendingMemberId = null;
  return id;
}
